import {
  Box,
  //Button,
  Dialog,
  //DialogActions,
  //DialogContent,
  DialogTitle,
  Grid,
  //Typography,
} from "@mui/material";
import React from "react";
import { dialogEditEvent } from "../../style2";


export default function DeletePopup({ open, handleClose }) {
  
  return (
    <Dialog open={open} onClose={handleClose} maxWidth='sm'>
      <Box sx={dialogEditEvent}>
        <Grid item xs={12} align='center'>
          <DialogTitle sx={{ textTransform: "uppercase" }}>Delete?</DialogTitle>
        </Grid>
      </Box>
    </Dialog>
  );
}
